import _find from 'lodash/find';
import _filter from 'lodash/filter';

import ConversationRequest from './ConversationRequest';
import ServerActions from '../actions/ServerActions';
import ParticipantActions from '../actions/ParticipantActions';

export default class ConversationSinceRequest extends ConversationRequest {
	constructor(reqGuid, restUrl, conversationId, since = 0) {
		super(reqGuid, restUrl, conversationId);
		this.since = since;
	}

	get asRequest () {
		return {
			body: {},
			method: 'get',
			tag: this.guid,
			uri: `${this.restUrl}Conversation/${this.conversationId}/Since?timestamp=${this.since}`
		}
	}

	resolve (response, statusCode) {
		return new Promise((resolve, reject) => {
			if (statusCode >= 400 && statusCode < 600) {
				console.log('<Since ERROR> ', response, statusCode);
				ServerActions.requestError(this.conversationId, statusCode, response.errorCode);
				reject(response);
			} else {
				if (response && response.length > 0) {
					//console.log('<Since> ', response);
					let responseEvent;

					if (_find(response, {type: 'conversationClosed'})) {
						ServerActions.conversationClosed(this.conversationId);
					}

					if (_find(response, {type: 'conversationSuspended'})) {
						ServerActions.conversationSuspended(this.conversationId);
					}

					//if (_find(response, {type: 'conversationResumed'})) {
					//	ConversationActions.conversationClosed(this.conversationId);
					//}

					if (responseEvent = _filter(response, {type: 'participantJoined'})) {
						ParticipantActions.participantJoined(this.conversationId, responseEvent);
					}

					if (responseEvent = _filter(response, {type: 'participantLeft'})) {
						ParticipantActions.participantLeft(this.conversationId, responseEvent);
					}

					if (responseEvent = _find(response, {messageType: 'browserInfo'})) {
						ServerActions.receiveBrowserInfo(this.conversationId, responseEvent);
					}

					ServerActions.receiveSince(response, this.conversationId);
				}
				resolve('since ok');
			}

		});

	}
}
